@let info = productInfo;
<fcom-modal
  [open]="open"
  [title]="info?.serviceInfo?.translations?.title ?? ''"
  [titleClasses]="'font-heading-2 pr-xsmall-y'"
  [buttons]="ModalButtons.CLOSE"
  [fitToContent]="true"
  (close)="closeModal.emit()"
  data-testid="product-info-modal"
>
  @if (info) {
    <div class="pr-medium-x ps-medium-y">
      @if (info.serviceInfo.media || info.descriptionText) {
        <div class="product-details">
          @if (info.serviceInfo.media; as imageData) {
            <div class="product-details__image" data-testid="product-info-modal-image">
              <fin-content-image
                [imageData$]="imageData | finToObservable"
                [aspectRatio$]="'4x3' | finToObservable"
                [enableLqip]="false"
                [isLazyLoad]="false"
              />
            </div>
          }
          @if (info.descriptionText) {
            <div
              class="product-details__description font-body-2 font-body-small nordic-blue-900-text"
              data-testid="product-info-modal-description"
              [innerHTML]="info.descriptionText"
            ></div>
          }
        </div>
      }
      @if (info.notificationKey | finLocalization; as resolvedNotification) {
        <fcom-notification
          class="block ps-medium-t"
          data-testid="product-info-modal-notification"
          [theme]="NotificationTheme.INFO"
          [scale]="NotificationScale.SMALL"
        >
          <span [innerHTML]="resolvedNotification"></span>
        </fcom-notification>
      }
      @if (info.contentUrlKey | finLocalization; as resolvedContentUrl) {
        <cms-unstyled-fragment
          class="block cms-content font-body-2 font-body-small ps-medium-t"
          data-testid="product-info-modal-content"
          [contentUrl$]="resolvedContentUrl | finToObservable"
          [showTitle]="true"
        />
      } @else if (info.contentHtml) {
        <div
          class="content-html font-body-2 font-body-small ps-medium-t"
          data-testid="product-info-modal-content"
          [innerHTML]="info.contentHtml"
        ></div>
      }
    </div>
  }
</fcom-modal>
